$(document).ready(function(){
    'use strict'

    //Вызов submit формы, если есть data-submit равный submit
    $('.checkbox__input').on('change', function () {
        hasDataAttrSubmit ($(this))
    })
});
